import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, putRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';

export const getProfile = async () => {
  const urlBuilder = createUrlBuilder('/profile');
  const result = await getRequest(LocateService, urlBuilder.toString());
  return result;
};

export const updateProfile = async (data: any) => {
  const urlBuilder = createUrlBuilder('/profile');
  const result = await putRequest(LocateService, urlBuilder.toString(), data);
  return result;
};

export const planUpgrade = async (data: any) => {
  const urlBuilder = createUrlBuilder('/profile/upgrade');
  const result = await putRequest(LocateService, urlBuilder.toString(), data);
  return result;
};

export const acceptEULA = async () => {
  const urlBuilder = createUrlBuilder('/profile/eula');
  const result = await putRequest(LocateService, urlBuilder.toString(), {});
  return result;
};

export const getEULA = async () => {
  const urlBuilder = createUrlBuilder('/eula');
  const result = await getRequest(LocateService, urlBuilder.toString());
  return result;
};

export const getMyLastEnquiry = async () => {
  const urlBuilder = createUrlBuilder('/me/lastEnquiry');
  const result = await getRequest(LocateService, urlBuilder.toString());
  return result;
};

export const getCredential = async () => {
  const urlBuilder = createUrlBuilder('/profile/getCredential');
  return await getRequest(LocateService, urlBuilder.toString());
};

export const getAnonymousCredential = async (params: any) => {
  const urlBuilder = createUrlBuilder(
    `/profile/external/${params.enquiryId}/getCredential?${params.token}`
  );
  return await getRequest(LocateService, urlBuilder.toString());
};

export const getSelfRestriction = async (type: string) => {
  const urlBuilder = createUrlBuilder(`/restrictions/me`);
  urlBuilder.addParameter('type', type);
  return await getRequest(LocateService, urlBuilder.toString());
};
